<script setup lang="ts">
import { ArrowRight, Check, Clock3, HeartHandshake, Ruler, ShieldCheck, Users } from "lucide-vue-next";
import "@/assets/styles/about.css";
</script>

<template>
  <main class="about-page">
    <section class="about-hero-new">
      <div class="about-wrap about-hero-grid">
        <div class="about-hero-copy">
          <span class="about-kicker">Über unseren Betrieb</span>
          <h1>Gutes Handwerk beginnt mit <em>Verantwortung.</em></h1>
          <p>Wir sind ein regional verwurzelter Dachdeckerbetrieb für Menschen, die Wert auf klare Worte, saubere Arbeit und langlebige Lösungen legen.</p>
        </div>
        <div class="about-hero-image">
          <img src="/images/home/team-v2.png" alt="Unser Dachdecker-Team bei der gemeinsamen Projektplanung" />
          <div class="about-image-label"><strong>Ein Team</strong><span>von der Beratung bis zur Abnahme</span></div>
        </div>
      </div>
    </section>

    <section class="about-numbers">
      <div class="about-wrap number-grid">
        <div><strong>15+</strong><span>Jahre Erfahrung</span></div><div><strong>420</strong><span>erfolgreiche Projekte</span></div><div><strong>6</strong><span>Kernleistungen</span></div><div><strong>1</strong><span>fester Ansprechpartner</span></div>
      </div>
    </section>

    <section class="about-story">
      <div class="about-wrap story-grid">
        <div class="story-copy">
          <span class="about-kicker dark">Was uns antreibt</span>
          <h2>Ein Dach ist mehr als Material über dem Kopf.</h2>
          <p>Es schützt, was Ihnen wichtig ist. Deshalb betrachten wir jedes Projekt mit der gleichen Sorgfalt – unabhängig davon, ob eine einzelne Undichtigkeit behoben oder ein komplettes Dach erneuert wird.</p>
          <p>Wir verbinden bewährte Handwerkstechniken mit zeitgemäßen Dachsystemen. Entscheidungen erklären wir verständlich, Termine planen wir realistisch und auf der Baustelle behandeln wir Ihr Zuhause mit Respekt.</p>
          <RouterLink to="/leistungen" class="about-link">Unsere Leistungen entdecken <ArrowRight /></RouterLink>
        </div>
        <div class="story-image"><img src="/images/home/handwerk-v2.png" alt="Präzise Handwerksarbeit an einem Dachanschluss" /></div>
      </div>
    </section>

    <section class="about-values">
      <div class="about-wrap">
        <div class="about-heading"><span class="about-kicker light">Unsere Haltung</span><h2>Woran Sie uns messen können.</h2></div>
        <div class="value-grid">
          <article><Ruler /><span>01</span><h3>Genau hinschauen</h3><p>Wir prüfen zuerst die Ursache und empfehlen dann die passende Lösung – nicht die größte.</p></article>
          <article><HeartHandshake /><span>02</span><h3>Verlässlich bleiben</h3><p>Klare Absprachen, ehrliche Aussagen und ein Ansprechpartner, der erreichbar bleibt.</p></article>
          <article><ShieldCheck /><span>03</span><h3>Sauber übergeben</h3><p>Wir dokumentieren unsere Arbeit und verlassen Baustellen so, wie wir sie selbst erwarten würden.</p></article>
        </div>
      </div>
    </section>

    <section class="about-process">
      <div class="about-wrap process-about-grid">
        <div><span class="about-kicker dark">Zusammenarbeit</span><h2>Persönlich statt anonym.</h2><p>Von der ersten Frage bis zur fertigen Übergabe wissen Sie, wer Ihr Projekt betreut.</p></div>
        <ul><li><Check /><div><strong>Vor-Ort-Termin</strong><span>Wir hören zu und prüfen die Gegebenheiten.</span></div></li><li><Check /><div><strong>Klare Empfehlung</strong><span>Sie verstehen Lösung, Umfang und Kosten.</span></div></li><li><Check /><div><strong>Koordinierte Umsetzung</strong><span>Das Team arbeitet planvoll und hält Sie auf dem Laufenden.</span></div></li></ul>
      </div>
    </section>

    <section class="about-contact-strip">
      <div class="about-wrap contact-strip-grid">
        <div><Users /><span><strong>Persönlich für Sie da</strong>Mo–Fr von 07:00 bis 17:00 Uhr</span></div>
        <div><Clock3 /><span><strong>Dringender Schaden?</strong>Schnelle Ersteinschätzung per Telefon</span></div>
        <RouterLink to="/kontakt">Gespräch vereinbaren <ArrowRight /></RouterLink>
      </div>
    </section>
  </main>
</template>
